<header class="header">
  <div class="header__backButtonContainer flex">
    @if (showIcon()) {
    <button pButton pRipple type="button" title="Regresar" icon="pi pi-arrow-left"
      class="p-button-rounded backButton p-0 flex" (click)="onBackButton()"></button>
    }
  </div>
</header>
